import { apiClient, httpCommunication } from "@uri/typed-api";

export type MediaAttachment =
  | { kind: "inline"; mimeType: string; dataBase64: string; caption?: string }
  | { kind: "file"; mimeType: string; fileUri: string; caption?: string };
import { fullApiDefinition } from "./apiTyping.ts";

export type SupergreenWebhookUpdate = {
  event?: "message" | "reaction" | "edit" | "disconnected";
  messageId?: string;
  quotedMsgId?: string;
  network: "whatsapp" | "telegram";
  chat: { id: string; username?: string; title?: string };
  author: { id: string; username?: string };
  text: string;
  attachments?: MediaAttachment[];
  time: number;
};

export const apiBaseUrl = "https://api.supergreen.cc";

export default apiClient(httpCommunication(apiBaseUrl), fullApiDefinition);
